import React from 'react'
import { useTranslation } from 'react-i18next'

import { DeleteIcon } from '../../icons/DeleteIcon'
import {
  MainContainer,
  FileNameContainer,
  UploadedImageIcon,
  FileNameText,
  DeleteButton,
  Retry
} from './styledComponents'

interface UploadedImageComponentTypes {
  uploadFileFunction?: () => any
  imageUrl: string | undefined
  fileName: string | undefined
  isDisabled?: boolean
  fileUploaderSend
  overrideBucketPath?: string
  fileExtension?: string
  extraBucketPath?: string
  onClickDeleteButton?: Function
  isUploadFailed: boolean
  onRetryUpload: () => void
  shouldShowDeleteButton?: boolean
}

export const UploadedImageComponent = (props: UploadedImageComponentTypes) => {
  const {
    fileName,
    isDisabled,
    onClickDeleteButton,
    isUploadFailed,
    onRetryUpload,
    shouldShowDeleteButton = true
  } = props
  const { t } = useTranslation()

  const renderDeleteButton = (): React.ReactNode =>
    shouldShowDeleteButton ? (
      <DeleteButton
        onClick={onClickDeleteButton}
        isDisabled={isDisabled}
        type="button"
      >
        <DeleteIcon />
      </DeleteButton>
    ) : null

  return (
    <MainContainer isDisabled={isDisabled}>
      <FileNameContainer>
        <UploadedImageIcon />
        <FileNameText>{fileName}</FileNameText>
      </FileNameContainer>
      {isUploadFailed ? (
        <Retry onClick={onRetryUpload}>{t('common.failureView.retry')}</Retry>
      ) : (
        renderDeleteButton()
      )}
    </MainContainer>
  )
}
